import { useCallback, useContext, useState } from "react";
import { UserContext } from "@app/user/UserContext";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { ViewMode } from "@app/network-portfolio-management/interfaces";
import { NPM_DASHBOARD_STYLE_CARDS, NPM_DASHBOARD_STYLE_ROWS } from "@app/shared/network-portfolio-management/constants";
import { networkPortfolioManagementStyleStorageKey } from "@app/shared/network-portfolio-management/utility";

const useNPMDashboardStyle = (): [ViewMode, (style: ViewMode) => void] => {
  const user = useContext(UserContext);
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const rowViewEnabled = enabledFeatureFlags.has(Features.ARGUS_PROJECT_DASHBOARD_ROW_VIEW_ENABLED);

  const [viewMode, setViewModeState] = useState<ViewMode>(() => {
    if (!user) return NPM_DASHBOARD_STYLE_CARDS;
    const stored = localStorage.getItem(networkPortfolioManagementStyleStorageKey(user));
    return stored === NPM_DASHBOARD_STYLE_ROWS ? "rows" : "cards";
  });

  const setViewMode = useCallback((style: ViewMode) => {
    if (user) {
      localStorage.setItem(networkPortfolioManagementStyleStorageKey(user), style);
    }
    setViewModeState(style);
  }, [user]);

  return [rowViewEnabled ? viewMode : "cards", setViewMode];
};

export default useNPMDashboardStyle;
